import { Chip, Stack, Box } from "@mui/material";

const ChipCsv = ({ value, size = "small", variant = "outlined" }) => {
  const parts = (value ?? "")
    .toString()
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);

  if (parts.length === 0) {
    return <Box sx={{ color: "text.disabled", fontStyle: "italic" }}>—</Box>;
  }

  return (
    <Stack
      direction="row"
      spacing={0.5}
      useFlexGap
      flexWrap="wrap"
      sx={{ alignItems: "center" }}
    >
      {parts.map((label, idx) => (
        <Chip key={`${label}-${idx}`} label={label} size={size} color="primary" variant={variant} />
      ))}
    </Stack>
  );
};

export default ChipCsv